import { Box } from '@mantine/core'
import { useOnShiftUsers } from '@/lib/on-shift-users-context'

type Props = {
  userId: string | null | undefined
  /** Явный цвет вместо расчёта по API (например, строки «на смене» в сводке) */
  forceOn?: boolean
  size?: number
}

export function ShiftPresenceDot({ userId, forceOn, size = 8 }: Props) {
  const { isOnShift } = useOnShiftUsers()
  if (!userId && forceOn === undefined) return null
  const on = forceOn !== undefined ? forceOn : isOnShift(userId)

  return (
    <Box
      title={on ? 'На смене' : 'Не на смене'}
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        flexShrink: 0,
        background: on
          ? 'var(--mantine-color-green-filled)'
          : 'var(--mantine-color-gray-5)',
      }}
    />
  )
}
